import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { useQueryClient } from 'react-query';
import { If } from 'src/components/If';

type ApproveOrRejectPendingWalletDialogProps = {
  open: boolean;
  action: 'accepted' | 'rejected';
  onClose: () => void;
  walletName: string;
  image: string;
  onConfirm?: () => void;
  isLoading: boolean;
  invalidateQueries?: string[][];
};

export function ApproveOrRejectPendingWalletDialog({
  open,
  action,
  onClose,
  walletName,
  image,
  onConfirm,
  isLoading,
  invalidateQueries = [],
}: ApproveOrRejectPendingWalletDialogProps) {
  const queryClient = useQueryClient();
  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (!isLoading) {
      onConfirm?.();
      invalidateQueries?.forEach((queryKey) => {
        queryClient.invalidateQueries(queryKey);
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          padding: '32px 20px 0',
          overflow: 'hidden',
          minHeight: '465px',
        }}>
        <img src={image} width={185} height={185} alt="Confirmação" />
        <Typography
          sx={{ padding: '0px 64px' }}
          variant="h4"
          textAlign="center">
          {action === 'accepted' ? 'Aceitar carteira' : 'Rejeitar carteira'}
        </Typography>
        <Typography
          maxWidth={430}
          textAlign="center"
          sx={{ fontSize: '0.875rem' }}>
          Tem certeza que deseja{' '}
          {action === 'accepted' ? 'aceitar' : 'rejeitar'}
          &nbsp;a carteira&nbsp;
          <strong>{walletName}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '12px',
          gap: 2,
        }}
        disableSpacing>
        <Button
          size="large"
          variant="outlined"
          color="secondary"
          onClick={handleClose}
          disabled={isLoading}
          sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          Cancelar
        </Button>
        <Button
          size="large"
          variant="contained"
          onClick={handleConfirm}
          disabled={isLoading}
          sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          <If condition={isLoading}>
            Aguarde... <CircularProgress size={20} />
          </If>
          <If condition={!isLoading}>Confirmar</If>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
